module.exports = __webpack_public_path__ + "img/test2.2bef2e63.png";